import { useMemo } from 'react';
import { SelectItem } from '../../types';
import { useWorkflows } from './useWorkflows';

/** SUBMITTER is the pipeline's first-stage node token (see Workflow.stageLabels). */
const SUBMITTER_TOKEN = 'SUBMITTER';

/** Default first option: no submitter-label restriction. */
export const ALL_SUBMITTERS_OPTION: SelectItem = { id: 'all', value: 'All Submitters' };

/**
 * Options for the accountant "submitter type" filter, derived live from the workflows:
 * "All Submitters" followed by every DISTINCT Submitter-stage (first-stage) DISPLAY-label override
 * configured across workflows (e.g. "Asset Servicer", "Operating Partner"), sorted alphabetically.
 *
 * The option id IS the label string — that's exactly what the backend filter matches against
 * (workflow.stageLabels->>'SUBMITTER'). New override labels appear here automatically, no code change.
 */
export function useSubmitterLabelOptions(): SelectItem[] {
  const { data: workflows } = useWorkflows();

  return useMemo(() => {
    const labels = new Set<string>();
    for (const workflow of workflows ?? []) {
      const label = workflow.stageLabels?.[SUBMITTER_TOKEN];
      if (typeof label === 'string' && label.trim()) {
        labels.add(label);
      }
    }
    const sorted = [...labels].sort((a, b) => a.localeCompare(b));
    return [ALL_SUBMITTERS_OPTION, ...sorted.map((label) => ({ id: label, value: label }))];
  }, [workflows]);
}
